import React from 'react';

import type { SelectProps } from '@vlabs/uikit/components/controls/select/Select';
import { Controller } from 'react-hook-form';

import { ValueSelect } from './ValueSelect';

export function ControllableValueSelect({
  isMulti = false,
  options = [],
  name,
  control,
  rules,
  ...selectProps
}: SelectProps): React.JSX.Element {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange } }) => (
        <ValueSelect
          isMulti={isMulti}
          name={name}
          onChange={onChange}
          options={options}
          value={value}
          {...selectProps}
        />
      )}
      rules={rules}
    />
  );
}
